import { type AnchorHTMLAttributes, type ReactNode } from 'react';
import { TextLink } from '../TextLink/index.tsx';

export type ConditionalTextLinkProps = {
  children: ReactNode;
  link: boolean;
  to: string;
} & AnchorHTMLAttributes<HTMLAnchorElement>;

export const ConditionalTextLink = ({ children, link, to, ...rest }: ConditionalTextLinkProps) =>
  link ? (
    <TextLink to={to} {...rest}>
      {children}
    </TextLink>
  ) : (
    children
  );
